import React from 'react'
import BaseField from './BaseField'
import { TagSelect } from 'components/tag'


export default function FieldTags(props) {
  /* Input Dropdown
   * Expected Props:
   * className = <string> Optional
   * label = <string> Required
   * required = <boolean> Optional
   * name = <string> Required
   * value = <string> Required
   * tags = <Array> Optional
   * setTags = <function()> Optional
   * defaultTags = <Array [{ name: "Tag 2", color: "#fef6ff" }]> Required
   * valid = <boolean> Optional
   * validMessage = <string> Optional
   * invalidMessage = <string> Optional
   * help = <string> Optional
   * helpAboveInput = <boolean> Optional
   * onChange = <function()> Required
   * onBlur = <function()> Optional
   * disabled = <boolean> Optional
   * readOnly = <boolean> Optional
   * prepend = <string> Optional
   * append = <string> Optional
   * multiple = <boolean> Optional
   * isLoading = <boolean> Optional
   * horizontal = <boolean> Optional
   * horizontalLabelSize = <int [1-23]> Optional (Default = 6)
   */
  
  const tags = props.value || []
  const setTags = value => props.onChange?.({ target: { value } })

  // RENDER
  return (
    <BaseField
      className={props.className}
      labelClassName={props.labelClassName}
      inputClassName={props.inputClassName}
      label={props.label}
      input={
        <TagSelect
          tags={props.tags || tags}
          setTags={props.setTags || setTags}
          defaultTags={props.defaultTags || []}
          valid={props.valid}
          disabled={props.disabled}
          readOnly={props.readOnly}
          isLoading={props.isLoading}
          placeholder={props.placeholder}
          allowClear={props.allowClear}
          onBlur={props.onBlur}
        />
      }
      prepend={props.prepend}
      append={props.append}
      disabled={props.disabled}
      readOnly={props.readOnly}
      required={props.required}
      valid={props.valid}
      validMessage={props.validMessage}
      invalidMessage={props.invalidMessage}
      help={props.help}
      helpAboveInput={props.helpAboveInput}
      horizontal={props.horizontal}
      horizontalLabelSize={props.horizontalLabelSize}
    />
  )
}
